import { render, staticRenderFns } from "./OptionsHeader.vue?vue&type=template&id=a11a8e16&"
import script from "./OptionsHeader.vue?vue&type=script&lang=js&"
export * from "./OptionsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports